import { createSlice } from "@reduxjs/toolkit";

export const topicsSlice = createSlice({
  name: "topics",
  initialState: {
    profileId: null,
    profileName: null,
    topicsTree: null,
  },
  reducers: {
    setTopicsTree: (state, action) => {
      state.profileId = action.payload.profileId;
      state.profileName = action.payload.profileName;
      state.topicsTree = action.payload.topicsTree;
    },
  },
});

export const { setTopicsTree } = topicsSlice.actions;

export default topicsSlice.reducer;
